/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Assistant_Prompt_Q3_C3Inputs */



/**
* | output |
* | --- |
* | "Structured, bullets and tables" |
*
* @param {Uno_Field_Assistant_Prompt_Q3_C3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_assistant_prompt_q3_c3 = /** @type {((inputs?: Uno_Field_Assistant_Prompt_Q3_C3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Assistant_Prompt_Q3_C3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Strukturiert, Stichpunkte und Tabellen")
	return /** @type {LocalizedString} */ ("Structured, bullets and tables")
});